// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".button-comp[data-v-a9a89322]{margin-bottom:10px;display:inline-block}.button-comp .button-name[data-v-a9a89322]{margin-left:10px}", ""]);
// Exports
module.exports = exports;
